import React from "react";
import Webcam from "react-webcam";
import PropTypes from "prop-types";

import Button from "../../../../component/button/Button";
import HeaderTag from "../../../../component/smallComponents/HeaderTag";
import SpinnerButton from "../../../../component/spinner/SpinnerButton";

const WebcamInput = ({
  imgSrc,
  capture,
  onSubmit,
  faceType,
  webcamRef,
  userLoading
}) => (
  <form onSubmit={onSubmit}>
    <HeaderTag
      type="h5"
      title="PLEASE STAND / SIT CLOSE TO WEBCAM, FOR CLEAR AND BIG FACE IMAGE"
      isClassName={true}
      className="text-danger"
    />
    <HeaderTag
      type="h4"
      title="WE RECOMMEND TO USE APP FOR GOOD QUALITY & ERROR FREE IMAGE REGISTRATION "
      isClassName={true}
      className="text-danger"
    />
    <div className="row mb-2">
      <div className="col-md-3 mt-4 col-xl-3 col-lg-3">
        <Webcam
          audio={false}
          ref={webcamRef}
          imageSmoothing={true}
          mirrored={true}
          className="img-thumbnail"
          screenshotFormat="image/jpeg"
        />
        <button onClick={capture} type="button">
          Capture photo
        </button>
      </div>
      <div className="col-md-3 mt-4 col-xl-3 col-lg-3">
        {imgSrc && <img className="img-thumbnail" src={imgSrc} />}
      </div>
      <div className="form-group text-center col-sm-3 mt-5 col-md-3  col-xl-3 col-lg-3">
        {userLoading ? (
          <SpinnerButton />
        ) : (
          <Button
            title={faceType}
            type="submit"
            className="btn text-white btn-block btn-dark"
            isBackgroundColor={false}
            icon="mdi mdi-plus-circle-outline mr-2"
          />
        )}
      </div>
    </div>
  </form>
);

WebcamInput.propTypes = {
  imgSrc: PropTypes.any.isRequired,
  capture: PropTypes.func.isRequired,
  onSubmit: PropTypes.func.isRequired,
  webcamRef: PropTypes.any.isRequired,
  faceType: PropTypes.string.isRequired,
  userLoading: PropTypes.bool.isRequired
};

export default WebcamInput;
